export default {
  snackbar: {
    text: '',
    button: true,
    timeout: 4000,
    color: '',
    show: false,
  },
  modal: {
    type: '',
    text: '',
    html: '',
    title: 'Aviso',
    v2: false,
    buttons: [
      {
        text: 'Confirmar',
        action: null,
        class: { primary: true },
      },
    ],
    closable: true,
    persistent: false,
    'max-width': '500px',
  },
  queueSnackModal: [],
}
